import React from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import { OrganizationTable } from '@teschglobal/tg-fhir-react-components'
import { Organization } from '@teschglobal/tg-fhir-react-components/dist/types'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import FhirLoader from '../../../../FhirLoader'

type NetworkListProps = {
    networks: any
    isFetching: boolean
    isLoading: boolean
    isSuccess: boolean
    clickViewDataLink: (organization: Organization) => void
    totalPages: number;
    currentPage: number;
    handleChangePage: (page: number) => void
}

const NetworkList: React.FC<NetworkListProps> = ({ networks, clickViewDataLink, isFetching, isLoading, totalPages, currentPage, handleChangePage }) => {
    const { data: environment } = useEnvironment()
    const rows: Organization[] = networks?.data ?? []

    return (
        <>
            <h3>Network</h3>
            {(isLoading || isFetching) ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        networks?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{networks?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                    <OrganizationTable
                        organizations={rows}
                        onRowLinkClick={clickViewDataLink}
                    />
                    {
                        networks?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default NetworkList
